import React from 'react';
import { useLocation } from 'react-router-dom';

const HeaderWallInvisible = () => {
  const location = useLocation();
  const isCheckoutPage = (location.pathname === '/checkout');
  return !isCheckoutPage ? <div className='Wall'> </div> : null;
};

export default HeaderWallInvisible;
